// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/currency-exchange/list',
    name: 'currency-exchange-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/administration/currencyExchange/List.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'comitions',
    },
  },
]

export default formTable
